import {
  isNotificationCode,
  type NotificationCode,
  type NotificationParams,
} from '@xtreed/academy-shared';
import i18n from '@/i18n';

export interface NotificationContent {
  code?: string | null;
  params?: NotificationParams | null;
  title?: string | null;
  message?: string | null;
}

const CHECKLIST_ACTIONS = ['post', 'comment', 'like'] as const;

function isChecklistAction(
  value: unknown,
): value is (typeof CHECKLIST_ACTIONS)[number] {
  return (CHECKLIST_ACTIONS as readonly unknown[]).includes(value);
}

function contextFor(code: NotificationCode, params: NotificationParams) {
  if (code === 'STREAK_MILESTONE') return String(params.streakDays ?? '');
  if (code === 'REWARD_STATUS_UPDATED') return String(params.status ?? '');
  return undefined;
}

function paramsFor(code: NotificationCode, params: NotificationParams) {
  if (code === 'DAILY_CHECKLIST_TASK' && isChecklistAction(params.action)) {
    return {
      ...params,
      actionLabel: i18n.t(`notifications:checklistActions.${params.action}`),
    };
  }
  return params;
}

export function notificationText(notification: NotificationContent) {
  const { code } = notification;
  if (!isNotificationCode(code)) {
    return {
      title: notification.title ?? '',
      message: notification.message ?? '',
    };
  }

  const params = paramsFor(code, notification.params ?? {});
  return {
    title: i18n.t(`notifications:${code}.title`, params),
    message: i18n.t(`notifications:${code}.message`, {
      ...params,
      context: contextFor(code, params),
    }),
  };
}
